/* unplugin-vue-components disabled */import { render } from "./SpeachDetails.vue?vue&type=template&id=395df1ab&scoped=true&ts=true"
import script from "./SpeachDetails.vue?vue&type=script&lang=ts"
export * from "./SpeachDetails.vue?vue&type=script&lang=ts"

import "./SpeachDetails.vue?vue&type=style&index=0&id=395df1ab&scoped=true&lang=scss"
import "./SpeachDetails.vue?vue&type=style&index=1&id=395df1ab&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395df1ab"]])

export default __exports__